import classNames from "classnames";
import React from "react";

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?:
    | "success"
    | "secondary"
    | "danger"
    | "warning"
    | "disabled"
    | "text"
    | "light"
    | "dark";

  block?: boolean;
  size?: "sm" | "md" | "lg";
}

export const Button: React.FC<ButtonProps> = (props) => {
  const {
    variant,
    children,
    className,
    block,
    size = "md",
    ...btnProps
  } = props;
  const classes = classNames(
    "btn",
    variant && `btn-${variant}`,
    size !== "md" && `btn-${size}`,
    block && "btnBlock",
    className
  );
  return (
    <button className={classes} {...btnProps}>
      {children}
    </button>
  );
};
